import { createFileRoute } from "@tanstack/react-router";
import TiffinPage from "@project/user/pages/programs/tiffin-seva";

export const Route = createFileRoute("/_user/_programs/tiffin-seva")({
  head: () => ({ meta: [{ title: "Tiffin Seva — Jivandhara" }] }),
  component: TiffinPage,
});
